// Psychologist/PsychologistAvatar.tsx

import React, {useState} from 'react';
import {IPsychologist} from '../../Types/psychology/psychologist';
import UserAvatar from 'User/UserAvatar';
import ContentCopyRoundedIcon from '@mui/icons-material/ContentCopyRounded';
import {useTheme} from 'Theme/ThemeContext';
import Modal from 'Core/components/elements/Modal/Modal';
import {Message} from 'Core/components/Message';
import StarRating from 'Core/components/StarRating';
import {DOMAIN_URL} from "Auth/axiosConfig";
import videoBtn from '../../Static/img/icon/video-button.svg'
import {FCCC} from "WideLayout/Layouts";
import {ContainerProps} from "WideLayout/Container";
import {Box} from "@mui/material";

interface PsychologistAvatarProps extends ContainerProps {
    psychologist: IPsychologist;
    size?: string;
}

const PsychologistAvatar: React.FC<PsychologistAvatarProps> = ({psychologist, size = '12rem', ...containerProps}) => {
    const {plt} = useTheme();
    const [videoSource, setVideoSource] = useState<string | null>(null);
    const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);

    const openVideoModal = (videoUrl: string) => {
        setVideoSource(videoUrl);
        setIsVideoModalOpen(true);
    };

    const closeVideoModal = () => {
        setVideoSource(null);
        setIsVideoModalOpen(false);
    };

    const handleCopyLink = () => {
        const url = `${DOMAIN_URL}/psychologists/${psychologist.user.id}`;
        navigator.clipboard.writeText(url).then(() => {
            Message.success('Ссылка скопирована в буфер обмена');
        }).catch(() => {
            Message.error('Не удалось скопировать ссылку');
        });
    };

    return (
        <>
            <Box {...containerProps} position={'relative'} height={'min-content'}>
                <UserAvatar
                    backBlur={'5px'}
                    zIndex={2}
                    roundedClassName={'rounded-4'}
                    size={size} // Замените на пропс, если необходимо
                    avatar={psychologist.user.avatar}
                />
                {psychologist.about_me_video_rutube && (
                    <FCCC rounded={6} top={5} left={5} pos={'absolute'}
                        // @ts-ignore
                          onClick={() => openVideoModal(psychologist.about_me_video_rutube)}
                          bg={plt.colors.secondary.main}
                          w={'2.19rem'} h={'2.19rem'} zIndex={5}
                          style={{
                              padding: '0.4rem',
                              cursor: 'pointer',
                          }}>
                        <img src={videoBtn}
                             className={`bg-transparent text-white-c5 rounded-circle`}
                             style={{
                                 cursor: 'pointer',
                                 zIndex: 5,
                                 width: '1.5rem',
                                 height: '1.5rem'
                             }}
                             alt={'video'}/>
                    </FCCC>
                )}
                <FCCC onClick={handleCopyLink}
                      rounded={6} top={5} right={5} pos={'absolute'}
                      bg={plt.colors.secondary.main}
                      w={'2.19rem'} h={'2.19rem'} zIndex={5}
                      style={{
                          padding: '0.4rem',
                          cursor: 'pointer',
                      }}>
                    <ContentCopyRoundedIcon
                        style={{
                            color: '#fffe',
                            fontSize: '1.5rem',
                        }}
                    />
                </FCCC>
                <StarRating
                    rating={psychologist.rating}
                    ratingWrapperClassName={'position-absolute z-5 bottom-0 left-0 w-100'}
                    ratingContentClassName={`frcc px-2 py-1 w-100 backdrop-blur-10 rounded-2`}
                    ratingValueClassName={`fs-6 fw-bold pt-2px me-1`}
                />
            </Box>

            <Modal
                zIndex={9}
                closeBtn={true}
                cls={'w-100 px-2'}
                isOpen={isVideoModalOpen}
                onClose={closeVideoModal}
            >
                {videoSource && (
                    <iframe
                        className={'maxw-1200px w-100 ratio-16-9 rounded-3'}
                        src={videoSource}
                        title="Psychologist Video"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    />
                )}
            </Modal>
        </>
    );
};

export default PsychologistAvatar;
